import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import {
    Box,
    Stack,
    Typography
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AutoSuggestion from "../../components/autocomplete";
import DateRangePickerComponent from "../../components/date/DateRangePickerComponent";
import { formatPrice, getFormatedDate, getUserType } from "../../utils/common";
import { ADMIN } from "../../utils/constant";
import { getAllBrandForDropDown } from "../brands/action";
import { getAllCompanyforDropdown } from "../subscriptions/action";
import { getDepositHistory } from "./action";
import { updateWallet } from "./walletSlice";
import CustomPagination from '../../utils/CustomPagination';

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort, isSticky } = props;
    const createSortHandler =
        (property) => (event) => {
            if (property === "action") {
                return;
            }
            onRequestSort(event, property);
        };

    const headCells = [
        {
            id: "dateTime",
            numeric: false,
            disablePadding: true,
            label: "Date & Time",
            type: "",
        },
        {
            id: "company",
            numeric: false,
            disablePadding: true,
            label: "Company",
            type: "",
        },
        {
            id: "amount",
            numeric: false,
            disablePadding: true,
            label: "Transaction ID",
            type: "",
        },

        {
            id: "amount",
            numeric: false,
            disablePadding: true,
            label: "Amount",
            type: "",
        },
        {
            id: "status",
            numeric: false,
            disablePadding: true,
            label: "Status",
            type: "",
        }
    ];

    return (
        <TableHead className={`hideActionSort ${isSticky} `}>
            <TableRow sx={{
                background: '#DBECFF !important', height: "50px", "& th": {
                    backgroundColor: "inherit !important"
                },
            }}>
                {headCells?.filter((v) => v.id !== getUserType())?.map((headCell) => {
                    return (
                        <TableCell
                            key={headCell?.id}
                            align={headCell.numeric ? "right" : "left"}
                            padding={headCell.disablePadding ? "none" : "normal"}
                            sortDirection={orderBy === headCell.id ? order : false}
                            sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : "asc"}
                                IconComponent={null}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === "desc"
                                            ? "sorted descending"
                                            : "sorted ascending"}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHead>
    );
}


export default function DepositHistory() {
    const navigate = useNavigate();
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("name");
    const dispatch = useDispatch();
    const {
        companyListing
    } = useSelector((state) => state.subscriptionSlice);
    const {
        limit,
        page,
        sort_key,
        totalPages,
        depositHistory,
        companyIds,
        startDate,
        pageRefresh
    } = useSelector((state) => state.walletSlice);

    const handleRequestSort = (
        event,
        property
    ) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
        dispatch(
            updateWallet({
                sort_type: isAsc ? "asc" : "desc",
                sort_key: property,
            }),
        );
        dispatch(getAllBrandForDropDown());
    };


    useEffect(() => {
        dispatch(getDepositHistory())
        dispatch(getAllCompanyforDropdown());
        return () => dispatch(updateWallet({
            depositHistory: [],
            startDate: "",
            endDate: "",
            companyIds: []
        }))
    }, [dispatch, navigate,]);
    const handleChange = (value) => {
        dispatch(updateWallet({ page: value - 1 }));
        dispatch(getDepositHistory());
    };
    const tableRef = useRef();
    const filter = startDate ? { startDate: startDate } : {}

    return (
        <>
            <div className="myCmpny d-flex flex-wrap align-items-center justify-content-end searcFilter p-3">
                <div className='allFilter walletDateRange '>
                    <div className="d-flex flex-wrap  gap-1" >
                        <span style={{ background: "white", borderRadius: 10, marginRight: `${(getUserType() === ADMIN) ? '15px' : '5px'}` }}>
                            <DateRangePickerComponent text="Date Range" getSelectedDate={(dates) => {

                                if (dates?.filter((v) => v)?.length === 2) {
                                    dispatch(updateWallet({ startDate: getFormatedDate(dates[0]), endDate: getFormatedDate(dates[1]) }));
                                    dispatch(getDepositHistory());
                                }

                            }} dateReset={filter} popperPlacement="bottom-start" />
                        </span>
                        {getUserType() === ADMIN &&
                            <Box sx={{ width: {sm:'400px',xs:'165px'}, }} className="searchdropdownwallet">
                                <AutoSuggestion
                                    multiple={true}
                                    sx={{ borderRadius: '50px !important', }}
                                    required={false}
                                    disableClearable={true}
                                    value={companyIds || []}
                                    className="auto-chips-cover"
                                    label={""}
                                    onChange={(e, newValue) => {
                                        dispatch(updateWallet({ companyIds: newValue }));
                                        dispatch(getDepositHistory());
                                    }}
                                    limitTags={2}
                                    key={pageRefresh}
                                    placeholder="Company"
                                    defaultValue={companyIds || []}
                                    id={`users-`}
                                    size="small"
                                    name="companyId"
                                    options={companyListing}
                                    isOptionEqualToValue={(option, value) => {
                                        if (
                                            value === "" ||
                                            option === "" ||
                                            value === option
                                        )
                                            return option;
                                    }}
                                    getOptionLabel={(option) =>
                                        option.companyName || ""
                                    }
                                    renderOption={(props, option) => {
                                        return (

                                            option.companyName && <Box
                                                key={option.companyName}
                                                component="li"
                                                sx={{
                                                    "& > img": { mr: 2, flexShrink: 0 },
                                                    fontFamily: "Poppins",
                                                }}
                                                {...props}
                                            >
                                                {option.companyName}
                                            </Box>
                                        );
                                    }} />
                            </Box>}
                        <RotateLeftIcon toolTip="Refresh page" size="small" sx={{ cursor: "pointer", color: '#6C7692', mt: 1.5 }}
                            onClick={() => {
                                dispatch(updateWallet({ startDate: "", endDate: "", pageRefresh: Math.random(), companyIds: [] }));
                                dispatch(getDepositHistory());
                            }} />
                    </div>
                </div>
            </div>
            <div>
                <TableContainer sx={{ maxHeight:"75vh" }} ref={tableRef}>
                    <Table stickyHeader aria-label="sticky table">
                        <EnhancedTableHead
                            order={order}
                            orderBy={sort_key}
                            onRequestSort={handleRequestSort}
                            numSelected={0}
                            onSelectAllClick={function (
                            ) {
                                throw new Error("Function not implemented.");
                            }} />
                        <TableBody>
                            {depositHistory && depositHistory?.length ? (
                                depositHistory?.map((row) => {
                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={row?.id}
                                            className={"tableRow"}
                                            sx={{
                                                "&:hover": {
                                                    backgroundColor: '#F0F7FF !important', "& td": {
                                                        backgroundColor: "inherit !important"
                                                    },
                                                }, height:'60px'
                                            }}>
                                            <TableCell component="td" scope="row">
                                                {row?.createdAt ? getFormatedDate(row?.createdAt?.toLocaleString(), "DD MMM YYYY hh:mm A") : "N/A"}

                                            </TableCell>
                                            {getUserType() === ADMIN &&
                                                <TableCell component="td" scope="row">
                                                    {row?.companyName || "N/A"}
                                                </TableCell>
                                            }
                                            <TableCell component="td" scope="row">
                                                {row?.txId || row?.orderId || "N/A"}
                                            </TableCell>

                                            <TableCell align="left">
                                                <div className="paymentDue">
                                                    ₹{formatPrice(row?.settlementAmount) || 0.0}
                                                </div>
                                            </TableCell>
                                            <TableCell align="left">
                                                <button className={row.status?.toLowerCase() + " capitalize-first-letter"}>{row.status}</button>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            ) : (
                                <TableRow colSpan={10}>
                                    <TableCell colSpan={10} style={{ textAlign: 'center' }}>
                                        <Typography
                                            color="inherit"
                                            variant="subtitle1"
                                            alignItems={"center"}
                                            component="h3">
                                            No Data found!
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Stack
                    sx={{
                        background: 'transparent',
                        height: '60px',
                        border: '1px solid #E9EAEB'
                    }}
                    direction="row"
                    alignItems={"center"}
                    justifyContent={"flex-end"}>
                    <CustomPagination
                        count={Math.ceil(totalPages / limit) || 0}
                        onChange={handleChange}
                        currentPage={page}
                        defaultPage={1} siblingCount={1} boundaryCount={1} />
                </Stack>
            </div>
        </>
    );
}
